export function message(lang) {
    const message = {
        "signIn": {
            "passwordReset": "パスワードリセット用メールを送信しました。",
            "authorization": "リクエスト処理中に問題が発生しました。",
            "passwordResetExpired":
                "パスワードリセットの有効期限が切れています。新たにリクエストしてください。",
        },
        "dashboard": {
            "passwordReset": "パスワードが正常に変更されました。",
        },
        "validation": {
            "common": "入力内容に不備があります。",
            "required": "この項目は入力必須です。",
            "taken": "この$1は既に登録済み、または削除待ちのデータに使用されています。",
            "minNumber": "$1は$2以上で入力してください。",
            // Add 2023.03.31 投稿分類
            "maxNumber": "$1は$2以下で入力してください。",
            "dictLabels": "分類辞書は別の辞書を選択してください。",
            "missingSelect": "上から順に選択してください。",
            "missingDictionaly": "ノイズ辞書か分類辞書を選択してください。",
            "rangeFromOver": "始点年月日時は3ヵ月以上前の設定はできません。",
            "rangeUntilOver": "終点年月日時は始点年月日時から3ヵ月以上の設定はできません。",
            "rangeOver": "期間指定の範囲は3ヵ月以内で設定してください。",
            "UntilOver": "期間指定は1年以上先は設定できません。",
            "keywordsCount": "入力キーワード数（$1）は$2（$3）以下で入力してください。",
            "emailRegexp": "メールアドレスを正しく入力してください。",
            "emailCount": "メールアドレスは最大10件まで登録できます。",
            "isPasswordRegexp": "パスワードを正しく入力してください。",
            "isPasswordMatch": "新しいパスワードと入力内容が一致しません。",
            "minDate": "「$1」以降の日付を入力してください。",
            "maxDate": "「$1」以前の日付を入力してください。",
            "dateRang": "指定した日付が適切ではありません。再度指定してください。",
            "isImportUrlRegexp": "URLを正しく入力してください。",
        },
        "errorMsg": {
            "continuousLoginErr": "連続してログインに失敗したため、一時的にログインが制限されています。",
            "requestLoginErr": "メールアドレスもしくはパスワードが間違っております。",
            "getManualErr": "マニュアルの取得に失敗しました。",
            "blobSizeZero": "指定期間にはデータが存在しません。",
            "overKeyword": "合計キーワード数が上限を超えております。",
            "lokedKeyword": "マスターユーザによりロックされています。",
            // Add 2023.03.31 投稿分類
            "overLimit": "登録の上限に達しています。",
            "undeliteable": "タスクが実行中の場合は削除できません。",
            "duplicateDictName": "登録済み辞書名は使用できません。",
            "duplicateTaskName": "登録済みタスク名は使用できません。",
            "dictUneditable": "「実行待ち」または「実行中」ステータスのタスクに設定されている辞書は編集できません。",
            // Add 2023.05.31
            "overGetKeywords": "取得キーワード数が上限を超えております。",
            "overExcludeKeywords": "除外キーワード数が上限を超えております。",
            "overMaxWordsOr": "収集キーワード数が上限を超えております。",
            "overMaxWordsAnd": "絞り込みキーワード数が上限を超えております。",
            "overMaxWordsNot": "除外キーワード数が上限を超えております。",
        },
    };

    return message;
}
